import {useQuery} from "@tanstack/react-query";

import {safelistingsService} from "../services";

type UseResidentHomeSafelistingsAccountabilityParams = {
  householdId: number | null;
  propertyId?: number | null;
  enabled?: boolean;
};

export function useResidentHomeSafelistingsAccountability({
  householdId,
  propertyId = null,
  enabled = true,
}: UseResidentHomeSafelistingsAccountabilityParams) {
  const isEnabled = enabled && householdId != null && propertyId != null;

  const query = useQuery({
    queryKey: ["safelistings", "resident-home-accountability", propertyId, householdId],
    queryFn: () =>
      safelistingsService.getResidentHomeAccountability(householdId!, propertyId!),
    enabled: isEnabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });

  return {
    ...query,
    accountability: query.isSuccess ? query.data : null,
  };
}
